import { appRequest } from "./services";

export type TPage = {
    id: number;
    titre: string;
    contenu: string;
};

export const getPage = async (id: number): Promise<TPage> => {
    const currentRequest = await appRequest<{
        data: TPage;
    }>({
        url: `pages/${id}?populate=*`,
    });

    return {
        ...currentRequest.data.data,
    };
};
